<app-site-header />

<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Mission Planner Software</h3>
        <p class="text-aerostar-orange">{{message}}</p>
        <p>
            Mission Planner software can be used to create autonomous missions, load autonomous missions
            to a drone, and interface with drone configuration parameters.
            <br><br>
            Mission Planner software requires MicroSoft Windows&#174; 10 or later.
            <br><br>
            AeroStar Dynamics customers and dealers can <a [routerLink]="[]" (click)="downloadMpInstall()">download
                Mission Planner</a>.
            <br><br>
            Installation and usage instructions can be found in the <a [routerLink]="[]"
                (click)="navigate('view-pdf', ['user-manual', 'Mission Planner User Manual.pdf'])">Mission Planner User Manual</a>.
            <br><br>
            <b>ToDo: </b>Describe download "gotchas".
        </p>
        <img style="width:650px;height:400px;margin-right:15px;" src="/Mission-Planner-snapshot.png" />
    </section>
</section>